import { ContentfulPreezieBanner } from '@jbhi-fi/apis/src/contentful/types';
import { PreezieFinderProps } from '../../PreezieFinder/PreezieFinder';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export abstract class PreezieBannerTransformer {
  static toPreezieFinderProps = (entry?: ContentfulPreezieBanner): PreezieFinderProps | undefined => {
    if (!entry?.fields?.guidekey || !entry?.fields?.placement) return undefined;
    const { guidekey, placement, title, heading, subText, icon } = entry.fields;
    return {
      title,
      heading,
      subText: subText ? documentToReactComponents(subText) : null,
      iconUrl: icon?.fields?.file?.url,
      guideKey: guidekey,
      placement,
    };
  };
}
